import styled from 'styled-components';
import { motion } from 'framer-motion';

export const QuizContainer = styled.div`
  max-width: 800px;
  margin: 4rem auto;
  padding: 3rem;
  background: ${props => props.theme.isDarkMode ? 'rgba(42, 42, 42, 0.8)' : 'rgba(255, 255, 255, 0.8)'};
  backdrop-filter: blur(10px);
  border-radius: 20px;
  box-shadow: ${props => props.theme.shadows.large};
  border: 1px solid ${props => props.theme.colors.border};
  text-align: center;
`;

export const StepTitle = styled.h2`
  color: ${props => props.theme.colors.darkGreen};
  font-size: 2rem;
  margin-bottom: 2rem;
`;

export const OptionsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1.5rem;
  margin-top: 2rem;
`;

export const OptionCard = styled(motion.button)`
  background: ${props => props.active ? props.theme.colors.darkGreen : props.theme.colors.background};
  color: ${props => props.active ? '#fff' : props.theme.colors.text};
  border: 2px solid ${props => props.active ? props.theme.colors.darkGreen : props.theme.colors.border};
  padding: 2rem;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 1.1rem;
  font-weight: 600;

  &:hover {
    border-color: ${props => props.theme.colors.darkGreen};
    transform: translateY(-5px);
  }
`;

export const InputWrapper = styled.div`
  max-width: 400px;
  margin: 2rem auto;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  text-align: right;
`;

export const Label = styled.label`
  font-weight: 500;
  color: ${props => props.theme.colors.text};
`;

export const Input = styled.input`
  width: 100%;
  padding: 1rem;
  border-radius: 8px;
  border: 1px solid ${props => props.theme.colors.border};
  background: ${props => props.theme.colors.background};
  color: ${props => props.theme.colors.text};
  font-size: 1.2rem;

  &:focus {
    outline: none;
    border-color: ${props => props.theme.colors.darkGreen};
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 3rem;
`;

export const NavButton = styled.button`
  padding: 0.8rem 2rem;
  border-radius: 8px;
  border: none;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  background: ${props => props.secondary ? 'transparent' : props.theme.colors.darkGreen};
  color: ${props => props.secondary ? props.theme.colors.text : '#fff'};
  border: ${props => props.secondary ? `1px solid ${props.theme.colors.border}` : 'none'};

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ProgressBar = styled.div`
  width: 100%;
  height: 8px;
  background: ${props => props.theme.colors.border};
  border-radius: 4px;
  margin-bottom: 3rem;
  overflow: hidden;
`;

export const ProgressFill = styled(motion.div)`
  height: 100%;
  background: ${props => props.theme.colors.darkGreen};
`;

